import { Product } from "../../product/product";

export class renameProduct {
    u: number;
    i: number;
    product: Product;
    constructor(u,i,product) {
        this.u =  u;
        this.i = i;
        this.product = product;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/rename/rename-product.ts